import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  ref: "form",
  class: "was-validated"
}
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "modalInputName",
  class: "form-label"
}, "Name", -1)
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "numberingSchemeGroup",
  class: "form-label"
}, "Nummerierung", -1)
const _hoisted_6 = {
  class: "input-group",
  id: "numberingSchemeGroup"
}
const _hoisted_7 = { class: "col-6 pe-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "inpColNumberScheme" }, "Spalten", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "inpRowNumberScheme" }, "Zeilen", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = {
  class: "input-group",
  id: "cornerCellIdentifierGroup"
}
const _hoisted_17 = { class: "col pe-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstColName",
  class: "form-label"
}, "erster Spaltenname", -1)
const _hoisted_19 = { class: "col" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastColName",
  class: "form-label"
}, "letzter Spaltenname", -1)
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = {
  class: "input-group",
  id: "cornerCellIdentifierGroup"
}
const _hoisted_23 = { class: "col pe-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstRowName",
  class: "form-label"
}, "erster Zeilenname", -1)
const _hoisted_25 = { class: "col" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastRowName",
  class: "form-label"
}, "letzter Zeilenname", -1)
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { class: "form-check" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  for: "inpQuadrantLettersActive",
  class: "form-check-label"
}, "Zellen in Quadrante unterteilen", -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Referenzpunkt 1", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "refPoint0Input",
  class: "form-label"
}, "Koordinaten", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "refPoint0IdentifierInput",
  class: "form-label"
}, "Bezeichnung", -1)
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Referenzpunkt 2", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "refPoint1Input",
  class: "form-label"
}, "Koordinaten", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  for: "refPoint1IdentifierInput",
  class: "form-label"
}, "Bezeichnung", -1)
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Kontrolle", -1)
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, "Zeilen", -1)
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, "Spalten", -1)
const _hoisted_47 = { class: "col" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "col-3" }, "Zellengrösse", -1)
const _hoisted_50 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PointInput = _resolveComponent("PointInput")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        id: "modalInputName",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.mutableValue.name) = $event)),
        required: ""
      }, null, 512), [
        [_vModelText, $data.mutableValue.name]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "aria-label": "Spaltennummerierung",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.mutableValue.xAxis.numberingScheme) = $event)),
            id: "inpColNumberScheme",
            required: ""
          }, [
            _createElementVNode("option", {
              value: $data.NumberingScheme.EXCEL_LETTERS
            }, "Buchstaben", 8, _hoisted_9),
            _createElementVNode("option", {
              value: $data.NumberingScheme.NUMBERS
            }, "Zahlen", 8, _hoisted_10)
          ], 512), [
            [_vModelSelect, $data.mutableValue.xAxis.numberingScheme]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "aria-label": "Zeilennummerierung",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.mutableValue.yAxis.numberingScheme) = $event)),
            id: "inpRowNumberScheme",
            required: ""
          }, [
            _createElementVNode("option", {
              value: $data.NumberingScheme.EXCEL_LETTERS
            }, "Buchstaben", 8, _hoisted_13),
            _createElementVNode("option", {
              value: $data.NumberingScheme.NUMBERS
            }, "Zahlen", 8, _hoisted_14)
          ], 512), [
            [_vModelSelect, $data.mutableValue.yAxis.numberingScheme]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("input", {
            id: "firstColName",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.mutableValue.xAxis.firstIdentifier) = $event)),
            ref: "firstColName",
            required: ""
          }, null, 512), [
            [_vModelText, $data.mutableValue.xAxis.firstIdentifier]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            id: "lastColName",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.mutableValue.xAxis.lastIdentifier) = $event)),
            ref: "lastColName",
            required: ""
          }, null, 512), [
            [_vModelText, $data.mutableValue.xAxis.lastIdentifier]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _withDirectives(_createElementVNode("input", {
            id: "firstRowName",
            class: "form-control",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.mutableValue.yAxis.firstIdentifier) = $event)),
            ref: "firstRowName",
            required: ""
          }, null, 512), [
            [_vModelText, $data.mutableValue.yAxis.firstIdentifier]
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _withDirectives(_createElementVNode("input", {
            id: "lastRowName",
            class: "form-control",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.mutableValue.yAxis.lastIdentifier) = $event)),
            ref: "lastRowName",
            required: ""
          }, null, 512), [
            [_vModelText, $data.mutableValue.yAxis.lastIdentifier]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.hasQuadrantLetters) = $event)),
          ref: "inpQuadrantLettersActive",
          id: "inpQuadrantLettersActive",
          class: "form-check-input"
        }, null, 512), [
          [_vModelCheckbox, $data.hasQuadrantLetters]
        ]),
        _hoisted_29
      ]),
      ($data.hasQuadrantLetters)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
              return _createElementVNode("div", {
                class: _normalizeClass({'col-6': true, 'd-inline-block': true, 'pe-2':i%2===1, 'pb-2':i%2===0}),
                key: i
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": ($event: any) => (($data.mutableValue.cellQuadrantLetters[i<3?i-1:(i===3?3:2)]) = $event),
                  class: "form-control",
                  required: ""
                }, null, 8, _hoisted_31), [
                  [_vModelText, $data.mutableValue.cellQuadrantLetters[i<3?i-1:(i===3?3:2)]]
                ])
              ], 2)
            }), 64))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", null, [
        _hoisted_34,
        _createVNode(_component_PointInput, {
          id: "refPoint0Input",
          "with-height": false,
          value: $data.mutableValue.refPoint0Coords,
          onValueChange: _cache[8] || (_cache[8] = val => $data.mutableValue.refPoint0Coords = val)
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_35,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.mutableValue.refPoint0Identifier) = $event)),
          class: "form-control",
          ref: "refPoint0Identifier",
          required: ""
        }, null, 512), [
          [_vModelText, $data.mutableValue.refPoint0Identifier]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _hoisted_37,
      _createElementVNode("div", null, [
        _hoisted_38,
        _createVNode(_component_PointInput, {
          id: "refPoint1Input",
          "with-height": false,
          value: $data.mutableValue.refPoint1Coords,
          onValueChange: _cache[10] || (_cache[10] = val => $data.mutableValue.refPoint1Coords = val)
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_39,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.mutableValue.refPoint1Identifier) = $event)),
          class: "form-control",
          ref: "refPoint1Identifier",
          required: ""
        }, null, 512), [
          [_vModelText, $data.mutableValue.refPoint1Identifier]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _hoisted_41,
      _createElementVNode("div", _hoisted_42, [
        _hoisted_43,
        _createElementVNode("span", _hoisted_44, _toDisplayString($options.checkValues.rowTitles), 1)
      ]),
      _createElementVNode("div", _hoisted_45, [
        _hoisted_46,
        _createElementVNode("span", _hoisted_47, _toDisplayString($options.checkValues.columnTitles), 1)
      ]),
      _createElementVNode("div", _hoisted_48, [
        _hoisted_49,
        _createElementVNode("span", _hoisted_50, _toDisplayString($options.checkValues.cellSize) + " m", 1)
      ])
    ])
  ], 512))
}